import React, {Component} from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

class CheckoutForm extends Component {
    constructor(props) {
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.state = {updatePaymentMode: props.data}
    }

    async handleOnChange(e){
        if(e.complete)
        {
            let {token} = await this.props.stripe.createToken({name: "Name"});
            if(token != null)
            {
                this.props.updateParent(token);
                return token;
            }
        }
        else
        {
            this.props.updateParent(null);
            return null;
        }
    }

    render() {
        return (
            <div className="checkout">
                { !this.state.updatePaymentMode ?
                    <p>
                        <Translate id="stripe-checkout.complete-payment" />
                    </p> : null
                }
                <CardElement onChange={this.handleOnChange} />
            </div>
        );
    }
}

export default injectStripe(CheckoutForm);